<template>
    <div id="orderlist">
        <el-row>
            <h2>仓库管理</h2>
        </el-row>
        <el-row>
            <el-form v-model="searchForm" ref="searchForm" :inline="true" style="padding: 0;margin: 0">
                <el-col :span="5">
                    <el-form-item label="项目点：">
                        <el-select v-model="searchForm.PROJECT" placeholder="请选择" filterable>
                            <el-option
                                v-for="item in projects"
                                   :key="item.value"
                                   :label="item.NAME"
                                   :value="item.ID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="产品名称：">
                        <el-input v-model="searchForm.PRODUCT_NAME"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-button @click="searchWarehouse">搜索</el-button>
                </el-col>
            </el-form>
        </el-row>
        <el-row>
            <el-col :span="2" v-show="flag == 1">
                <el-button @click="addWarehouse">新增仓库</el-button>
            </el-col>
            <el-col :span="2" v-show="flag == 0">
                <el-button @click="openDialog">新增商品</el-button>
            </el-col>
            <el-col :span="20">
                <span style="float: right;">总价值：{{worth}}</span>
            </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
            <el-col :span="24">
                <el-table :data="tableData"  stripe border>
                    <el-table-column type="index" label="序号"  width="50" ></el-table-column>
                    <el-table-column prop="PRODUCT_CODE" label="产品编码"  min-width="50"></el-table-column>
                    <el-table-column prop="NAME" label="产品名称"  min-width="100"></el-table-column>
                    <el-table-column prop="TYPE_UNIT" label="单位"  min-width="100"></el-table-column>
                    <el-table-column prop="PRODUCT_COUNT" label="库存数量"></el-table-column>
                    <el-table-column prop="PRODUCT_PRICE" label="价格"> </el-table-column>
                    <el-table-column prop="PRODUCT_WORTH" label="总价值"  min-width="40" > </el-table-column>
                    <el-table-column  fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="small" @click="openEdit(scope.row)">修改</el-button>
                            <el-button type="text" icon="el-icon-close" style="color: red" size="small" @click="deleteProduct(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-dialog
                        title="新增商品信息"
                        :visible.sync="addDialogVisible"
                        width="30%"
                        center @close="close" :close-on-click-modal="false">
                    <el-form v-model="addForm" ref="addForm">
                        <el-form-item label="产品编码：" :label-width="formLabelWidth">
                            <el-input v-model="addForm.PRODUCT_CODE"></el-input>
                        </el-form-item>
                        <el-form-item label="库存数量：" :label-width="formLabelWidth">
                            <el-input v-model="addForm.PRODUCT_COUNT"></el-input>
                        </el-form-item>
                        <el-form-item label="产品价格：" :label-width="formLabelWidth">
                            <el-input v-model="addForm.PRODUCT_PRICE"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="close">取 消</el-button>
                        <el-button type="primary" @click="addProduct">确 定</el-button>
                    </span>
                </el-dialog>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-dialog
                        title="修改商品信息"
                        :visible.sync="editDialogVisible"
                        width="30%"
                        center @close="close">
                    <el-form v-model="editForm" ref="editForm">
                        <el-form-item label="产品编码：" :label-width="formLabelWidth">
                            <el-input v-model="editForm.PRODUCT_CODE"></el-input>
                        </el-form-item>
                        <el-form-item label="库存数量：" :label-width="formLabelWidth">
                            <el-input v-model="editForm.PRODUCT_COUNT"></el-input>
                        </el-form-item>
                        <el-form-item label="产品价格：" :label-width="formLabelWidth">
                            <el-input v-model="editForm.PRODUCT_PRICE"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="close">取 消</el-button>
                        <el-button type="primary" @click="editProduct">确 定</el-button>
                    </span>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      searchForm: {},
      projects: [],
      tableData: [],
      flag: 3,
      addDialogVisible: false,
      addForm: {},
      formLabelWidth: '120px',
      editForm: {},
      editDialogVisible: false,
      worth: '',
    };
  },
  created() {
    this.queryProject();
  },
  methods: {
    queryProject() {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 8,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TC_ID: sessionStorage.getItem('companyId'),
      };
      http.post(params).then((result) => {
        this.projects = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    searchWarehouse() {
      if (this.searchForm.PRODUCT_NAME) {
        const params = {
          SERVICE_ID: '11001',
          OTYPE: 4,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          PROJECT_ID: this.searchForm.PROJECT,
          PRODUCT_NAME: this.searchForm.PRODUCT_NAME,
        };
        http.post(params).then((result) => {
          this.tableData = result.list;
          this.worth = result.TOTAL_WORTH;
          this.flag = 0;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.tableData = [];
        });
      } else {
        const params = {
          SERVICE_ID: '11001',
          OTYPE: 3,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          PROJECT_ID: this.searchForm.PROJECT,
        };
        http.post(params).then((result) => {
          this.tableData = result[0].list;
          this.flag = 0;
          this.worth = result[0].TOTAL_WORTH;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.tableData = [];
          this.flag = 1;
        });
      }
    },
    addWarehouse() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11001',
            OTYPE: 1,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            PROJECT_ID: this.searchForm.PROJECT,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '新增仓库成功', type: 'success' });
            this.flag = 0;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    openDialog() {
      this.addDialogVisible = true;
    },
    close() {
      this.addDialogVisible = false;
      this.addForm = {};
    },
    addProduct() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11001',
            OTYPE: 2,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            PROJECT_ID: this.searchForm.PROJECT,
            PRODUCT_CODE: this.addForm.PRODUCT_CODE,
            PRODUCT_COUNT: this.addForm.PRODUCT_COUNT,
            PRODUCT_PRICE: this.addForm.PRODUCT_PRICE,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addDialogVisible = false;
            this.searchWarehouse();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    deleteProduct(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11001',
            OTYPE: 5,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            PROJECT_ID: this.searchForm.PROJECT,
            PRODUCT_CODE: row.PRODUCT_CODE,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.searchWarehouse();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    openEdit(row) {
      this.editDialogVisible = true;
      this.editForm = row;
    },
    editProduct() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11001',
            OTYPE: 6,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            PROJECT_ID: this.searchForm.PROJECT,
            PRODUCT_CODE: this.editForm.PRODUCT_CODE,
            PRODUCT_COUNT: this.editForm.PRODUCT_COUNT,
            PRODUCT_PRICE: this.editForm.PRODUCT_PRICE,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editDialogVisible = false;
            this.searchWarehouse();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/putoutStorage.vue